import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { UNVISITED_SITES } from "../apiEndpoints";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import useFetchData from "../../../CustomHooks/useAxios/useFetchData";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";
import { UnvisitedSitesHeader } from "../components/unvisitedSites/UnvisitedSitesHeader";
import { SummaryCard } from "../components/unvisitedSites/SummaryCard";
import { SiteTable } from "../components/unvisitedSites/SiteTable";
import UnvisitedSiteTableControls from "../components/unvisitedSites/UnvisitedSiteTableControls";
import { setData, setCopyData } from "../../../redux/dataSlice";
import { getPriority } from "../utils/siteHelpers";
import { AllSitesUpToDate } from "../components/unvisitedSites/AllSitesUpToDate";

const UnVisitedSitesPage = () => {
  const { isLoaded } = useFetchData(UNVISITED_SITES);
  const data = useSelector((state) => state.data.data);
  const originalData = useSelector((state) => state.data.copyData);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);
  const dataLength = isLoaded && !errMsg ? data.length : 0;
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoaded && !error) {
      const formattedSites = data.map((site) => ({
        ...site,
        priority: getPriority(site.daysSinceLastVisit),
      }));

      dispatch(setData(formattedSites));
      dispatch(setCopyData(formattedSites));
    }
  }, [isLoaded, error]);

  return (
    <MainPageLayout
      headerConfig={{ title: "Unvisited Sites" }}
      numberOfData={dataLength}
      bgColor="bg-[#f0f2f7]"
    >
      {isLoaded && !error ? (
        <>
          <UnvisitedSitesHeader />
          <SummaryCard />
          {originalData.length > 0 && <UnvisitedSiteTableControls />}
          {originalData.length > 0 ? <SiteTable /> : <AllSitesUpToDate />}
        </>
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default UnVisitedSitesPage;
